import { object, string } from 'decoders';
import { Entity } from '.';
import { Decodify, isodate } from './decoders';

export interface APIKeyType extends Entity {
  name: string;
}

export interface APIKey {
  id?: string;
  type: string;
  name: string;
  token?: string;
  expires_at?: Date;
  token_qrcode?: string;
}

export const apiKeyDecoder = object<Decodify<APIKey>>({
  id: string,
  type: string,
  name: string,
  token: string,
  expires_at: isodate,
  token_qrcode: string,
});

export const apiKeyEncoder = function (apiKey: APIKey) {
  return {
    id: apiKey.id,
    type: apiKey.type,
    name: apiKey.name,
    expires_at: apiKey.expires_at ? apiKey.expires_at.toISOString() : null,
  };
};
